<template>
    <div class="page cardsManageSection">
        <TopNavBar class="mb-4"/>
        <div class="wrapBox">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h1>Scan Card</h1>
                    </div>
                    <div class="text-center my-3 col-12" v-if="gift_card">
                        <svg class="barcode w-100" :jsbarcode-value="gift_card.card_number"></svg>
                    </div>
                    <div class="kettlCardsBox col-12">
                        <h1>Reload</h1>
                        <GiftCardAmount v-if="gift_card" :gcard="gift_card"/>
                        <CartPaymentsOption v-if="loaded"/>
                    </div>
                    <div class="col-12">
                        <button @click="refill" class="zbg">
                            Refill Card
                        </button>
                    </div>
                    <div class="col-12 mt-5" v-if="card_history">
                        <h1>Card history</h1>
                        <div class="cardWrap" >
                            <div class="el d-flex flex-wrap mb-4" v-for="inf in card_history" style="max-width: 500px">
                                <div class="d-flex align-items-center w-100 justify-content-between">
                                    <h5 class="mr-2">{{ dateTransform(inf.transaction_datetime) }}</h5> <h5 class="colorCrimson"><span v-if="inf.transaction_type != 'DEDUCTION'">+</span>{{ inf.transaction_amount}}</h5>
                                </div>
                                <div class="w-100 d-flex justify-content-between"><span>Total:</span><span class="colorCrimson">{{ inf.new_balance }}</span></div>
                            </div>
                        </div>
    
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import GiftCardsList from "../../components/checkout/GiftCardsList";
    import TopNavBar from "../../components/shared/TopNavBar";
    import CartPaymentsOption from "../../components/checkout/CartPaymentsOption";
    import * as JsBarcode from 'jsbarcode';
    import GiftCardAmount from "../../components/checkout/GiftCardAmount";
    import moment from "moment";

    export default {
        name: "EditGiftCard",
        components: {GiftCardAmount, CartPaymentsOption, TopNavBar, GiftCardsList},
        data() {
            return {
                gift_card: null,
                card_history: null,
                loaded: false,
            }
        },
        created() {
            this.$store.commit("shared/setTopBar", {title: "Manage Gift Card", showBackButton: true});
            this.$store.dispatch("cart/getGiftCards", {
                callback: data => {
                    //console.log(data);
                    this.gift_card = data.find(el => el.card_id == this.$route.params.cardId);
                    this.$set(this.gift_card,'amount','25');
                    this.$set(this.gift_card,'custom_ammount',0);
                    this.$store.dispatch("shared/getGatewayInfo", {
                        giftcardTypeId: this.gift_card.gift_card_type_id,
                        callback: () => this.loaded = true
                    })
                    this.$nextTick(() => JsBarcode(".barcode").init())
                }
            });
            console.log(this.gift_card);
            this.$store.dispatch("cart/getGiftCardHistory", {
                        id: this.$route.params.cardId,
                        callback: data => {
                            console.log(data);
                            this.card_history = data;
                        }
                    }
            );
        },
        methods:{
            refill(){
               this.$store.dispatch("giftcard/refillGiftCard", {
                   data:{
                       amount: this.gift_card.amount === 'custom' ? this.gift_card.custom_ammount : this.gift_card.amount,
                       gift_card_id: this.gift_card.card_id,
                       payment_method : "credit_card",
                       payment_data : this.$store.state.cart.cart.card.credit_card_id
                   },
                   callback: () => this.$router.go(-1)
               });
            },
            dateTransform(date) {
                return moment(date).format("MMM DD [AT] h:mm a")
            },
        }
    }
</script>
